"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = ViewList;

var _ViewList = require("@adobe/react-spectrum-workflow/dist/ViewList.js");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function ViewList(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_ViewList.A4uViewList, null));
}